export default __webpack_public_path__ + "static/media/sport-100-kls-moto.2af991c3.png";